<template>
  <v-list nav dense>
    <template>
      <v-list-item link router to="/home" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('inicio') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-school" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Academia de Golf</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/academy" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Panel Principal
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/academy/teachers" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-tie</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Profesores
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/academy/clinics" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-calendar-clock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Clínicas
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/academy/students" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Alumnos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item link router to="/settings" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-cog-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('configuracion') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('Ayuda') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'academy'
}
</script>

<style scoped>
.list:hover {
  background: white;
  opacity: 0.85;
}
</style>
